<!-- /* [NT-APPLY-COM-POP] 기업매칭신청 */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      title="매칭 신청하기"
      v-if="data"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <div class="popupViewProfileCardImage">
          <figure class="networkSearchItemImage">
            <img
              :src="getAvatarLink(data.avatar, getDefaultAvatar($role.CORP))"
              alt="미국 국기"
            />
          </figure>
          <div class="popupViewProfileCardImageText">
            <h3 class="popupViewProfileCardImageTitle">
              {{ data.name }}
            </h3>
            <h5 class="popupViewProfileCardImageDesc">
              {{ data.phoneNumber }}
            </h5>
            <h5 class="popupViewProfileCardImageEmail">
              {{ data.email }}
            </h5>
            <MainButton
              btnText="홈페이지"
              customFontSize="16px"
              width="116px"
              customHeight="32px"
              @click="gotoHome(data.homePage)"
              v-if="data.homePage"
            />
          </div>
        </div>

        <h6
          class="popupViewProfileHeadline"
          style="padding-bottom: 0px !important;"
        >
          매칭 프로세스
        </h6>
        <MatchingProcess />

        <section>
          <h3 class="matchingHeadLine">신청서 작성</h3>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form
              id="formNTApplyComPopup"
              @submit.prevent="handleSubmit(onClickSubmitForm)"
              class="aRow5"
            >
              <div style="margin-bottom: 50px;">
                <InputField
                  label="신청 대상 기업"
                  v-model="data.company"
                  readonly
                />
                <ValidationProvider
                  name="매칭신청 사유"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="매칭신청 사유"
                    :errors="errors"
                    v-model="form.requestReason"
                  />
                </ValidationProvider>

                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">
                  연락처 정보
                </h3>
                <InputField label="신청자 이름" v-model="user.name" readonly />
                <InputField label="이메일 주소" v-model="user.email" readonly />
                <InputField
                  label="전화번호"
                  v-model="user.phoneNumber"
                  readonly
                />
              </div>
            </form>
          </ValidationObserver>
        </section>
      </div>
      <template #footer>
        <MainButton
          form="formNTApplyComPopup"
          type="submit"
          btnText="신청서 전송"
          :disabled="disabledSubmit"
        />
      </template>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";
import InputField from "@/components/formControl/InputField.vue";
import MatchingProcess from "@/components/items/MatchingProcess.vue";

export default {
  name: "NTApplyComPopup",
  components: {
    BasicModal,
    MainButton,
    ValidationObserver,
    ValidationProvider,
    TextAreaInputField,
    InputField,
    MatchingProcess,
  },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
    data: Object,
  },
  data() {
    return {
      disabledSubmit: false,
      user: {
        ...this.$store.state.auth.user,
        phoneNumber:
          this.$store.state.auth.user.phone ||
          this.$store.state.auth.user.phoneNumber,
      },
      form: {},
    };
  },
  methods: {
    onClickSubmitForm() {
      const that = this;
      this.disabledSubmit = true;
      this.$store
        .dispatch("directMatching/createDirectMatching", {
          requesterIdx: this.user.idx,
          requestedIdx: this.data.idx,
          ...this.form,
        })
        .then((response) => {
          if (response.status == 200) {
            if (this.handleToggleModal) this.handleToggleModal();
            that.$alert("알림", "제출해주셔서 감사합니다");
          } else {
            this.$alert("Error", response.error?.message, "error");
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          that.disabledSubmit = false;
          if (this.handleToggleModal) this.handleToggleModal();
        });
    },
    gotoHome(link) {
      window.open(link, "_blank");
    },
  },
  watch: {
    isModal(val) {
      if (!val) this.form = {};
    },
  },
};
</script>

<style lang="scss" scoped></style>
